export default __webpack_public_path__ + "static/media/bulk_unarchive.4b09cb5d.png";